export default function addScript(src, attributes, defer = false) {
  const scriptTag = document.createElement('script')
  scriptTag.type = 'text/javascript'

  if (attributes) {
    Object.keys(attributes).forEach(key => {
      scriptTag.setAttribute(key, attributes[key])
    })
  }

  if (defer) {
    scriptTag.defer = true
  }

  const firstScript = document.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(scriptTag, firstScript)

  scriptTag.src = src
}

export function addAsyncScript(src) {
  return new Promise((resolve, reject) => {
    const scriptTag = document.createElement('script')
    scriptTag.type = 'text/javascript'
    scriptTag.async = true

    scriptTag.addEventListener('load', () => {
      resolve(scriptTag)
    })

    scriptTag.addEventListener('error', event => {
      try {
        // `ErrorEvent` isn't available in IE, so we catch that error.
        const error = new ErrorEvent(event)
        reject(new Error(`${src} failed to load with message: ${error.message}`))
      } catch (e) {
        reject(new Error(`${src} failed to load`))
      }
    })

    scriptTag.src = src
    document.head.appendChild(scriptTag)
  })
}
